export default "__VITE_ASSET__VKeH4Rw0__"